import React, { useState } from 'react';
import axios from 'axios';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Container,
  Link,
  Paper,
  Snackbar,
  TextField,
  Typography
} from '@mui/material';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import apiUrl from '../config';
import '../CSS/ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleanEmail = email.trim().toLowerCase();
    if (!cleanEmail) {
      setNotification({ open: true, message: 'Veuillez renseigner votre adresse email.', severity: 'error' });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${apiUrl}/forgot-password`, { email: cleanEmail });
      setNotification({
        open: true,
        message: response.data?.message || "Si un compte existe, un lien vient d'être envoyé.",
        severity: 'success',
      });
      setEmail('');
    } catch (error) {
      setNotification({
        open: true,
        message: error.response?.data?.message || "Erreur lors de l'envoi du lien de réinitialisation.",
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="forgot-page">
      <Container maxWidth="lg" className="forgot-shell">
        <Paper elevation={0} className="forgot-card">
          <Box className="forgot-brand-panel">
            <img src="/NOVA PORTAGE Main Logo.png" alt="NOVA Portage" className="forgot-logo" />
            <Typography className="forgot-eyebrow">Espace sécurisé</Typography>
            <Typography variant="h3" component="h1" className="forgot-title">
              Mot de passe oublié ?
            </Typography>
            <Typography className="forgot-subtitle">
              Indiquez votre email. Si un compte existe, vous recevrez un lien sécurisé pour créer un nouveau mot de passe.
            </Typography>
          </Box>

          <Box className="forgot-form-panel">
            <Link component={RouterLink} to="/login" className="forgot-back-link">
              <ArrowBackRoundedIcon fontSize="small" /> Retour à la connexion
            </Link>

            <Typography variant="h4" component="h2" className="forgot-form-title">
              Recevoir mon lien
            </Typography>
            <Typography className="forgot-form-help">
              Le lien expire rapidement pour protéger votre compte.
            </Typography>

            <form onSubmit={handleSubmit} className="forgot-form">
              <TextField
                fullWidth
                label="Adresse email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                InputProps={{
                  startAdornment: <MailOutlineRoundedIcon className="forgot-input-icon" />,
                }}
              />

              <Button type="submit" variant="contained" fullWidth className="forgot-submit" disabled={loading}>
                {loading ? 'Envoi en cours...' : 'Envoyer le lien sécurisé'}
              </Button>
            </form>
          </Box>
        </Paper>
      </Container>

      <Snackbar
        open={notification.open}
        autoHideDuration={5000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={notification.severity} sx={{ width: '100%', fontWeight: 700 }}>
          {notification.message}
        </Alert>
      </Snackbar>
    </main>
  );
};

export default ForgotPassword;
